import React from "react";
import RoomContext from "../../../context/RoomContext";
import PropTypes from "prop-types";
import { RIEInput } from "riek";

const EditableInput = ({
  value,
  propName,
  className,
  classLoading,
  classInvalid,
}) => {
  const { roomClient } = React.useContext(RoomContext);
  return (
    <RIEInput
      value={value}
      propName={propName}
      className={className}
      classLoading={classLoading}
      classInvalid={classInvalid}
      shouldBlockWhileLoading
      editProps={{
        maxLength: 30,
        autoCorrect: "off",
        spellCheck: false,
      }}
      change={({ newDisplayName }) =>
        roomClient.changeDisplayName(newDisplayName)
      }
    />
  );
};

EditableInput.propTypes = {
  value: PropTypes.string,
  propName: PropTypes.string.isRequired,
  className: PropTypes.string,
  classLoading: PropTypes.string,
  classInvalid: PropTypes.string,
};

export const EditableInputMemoized = React.memo(EditableInput);
EditableInputMemoized.displayName = "EditableInputMemoized";

export default EditableInput;
